export interface IApiLogsFilter {
  userId?: string;
  originalUrl?: string;
  appPlatform?: string;
  appVersion?: string;
  creationDate?: string;
}

export const ApiLogsFilter: IApiLogsFilter = {};
